export enum BackgroundColor {
    Transparent = "bg-transparent",
    White = "bg-white",
    Blue = "bg-blue-600",
}